import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('Attachment')
export class Attachment {
    @JsonProperty('question_no')
    question_no = 0;

    @JsonProperty('choice_no')
    choice_no = 0;

    @JsonProperty('new_file_name')
    new_file_name = '';

    constructor() {

    }
}